import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';
import { useOnboarding } from '@/hooks/useOnboarding';
import { useMinShow } from '@/hooks/useMinShow';
import FullScreenLoader from '@/components/ui/FullScreenLoader';
import { AUTH_ENABLED } from '@/lib/prelaunch';

export default function ProtectedRoute() {
  const { session, isAuthLoading, isProfileLoading } = useAuth();
  const { hasCompletedOnboarding } = useOnboarding();

  const showLoader = useMinShow(isAuthLoading || isProfileLoading, 1400);

  if (isAuthLoading) return <FullScreenLoader />;
  if (!session) return <Navigate to={AUTH_ENABLED ? '/auth' : '/'} replace />;
  if (showLoader) return <FullScreenLoader />;
  if (!hasCompletedOnboarding) return <Navigate to="/onboarding/name" replace />;
  return <Outlet />;
}
